import ApiService from "@/services/api.service";
import JwtService from "@/services/jwt.service";
import OidcService from "@/services/oidc.service";
import jwt_decode from "jwt-decode";

// action types
export const LOGIN = "login";
export const GET_CURRENT_USER = "getCurrentUser";
export const LOGOUT = "logout";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_USER = "setCurrentUser";
export const SET_ERROR = "setError";

const state = {
    error: {},
    user: {},
    currentUser: {},
    isAuthenticated: !!JwtService.getToken(),
    requiresTwoFactor: false,
    emailNotConfirmed: false,
};

const getters = {
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    currentUser(state) {
        return state.currentUser;
    },
    requiresTwoFactor(state) {
        return state.requiresTwoFactor;
    },
    emailNotConfirmed(state) {
        return state.emailNotConfirmed;
    },
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("Authentication", credentials)
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, "Credenziali non valide!");
                    setTimeout(() => {
                        context.commit(SET_ERROR, "");
                        reject(response);
                    }, 5000);
                });
        });
    },
    [GET_CURRENT_USER](context) {
        if (!JwtService.getToken()) return;

        // Con SSO il token è di Keycloak: il primo claim non è lo username.
        // Si usa l'endpoint /Authentication/me che risolve l'utente dall'identità.
        const request = OidcService.enabled
            ? ApiService.get("Authentication/me")
            : (() => {
                  const decodedToken = jwt_decode(JwtService.getToken());
                  const username = decodedToken[Object.keys(decodedToken)[0]];
                  return ApiService.download("Users/ByUsername", username);
              })();

        return new Promise((resolve, reject) => {
            request
                .then(({ data }) => {
                    context.commit(SET_USER, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => {
                        context.commit(SET_ERROR, "");
                    }, 5000);
                    reject(response);
                });
        });
    },

    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
        if (OidcService.enabled) {
            OidcService.logout();
        }
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_AUTH](state, user) {
        const requiresTwoFactor = user?.requiresTwoFactor === true;
        const emailNotConfirmed = user?.emailNotConfirmed === true;
        state.requiresTwoFactor = requiresTwoFactor;
        state.emailNotConfirmed = emailNotConfirmed;
        state.user = requiresTwoFactor ? {} : user;
        state.isAuthenticated = !requiresTwoFactor && !emailNotConfirmed && !!user?.token;
        state.error = {};

        if (state.isAuthenticated) {
            JwtService.saveToken(user.token);
        } else {
            JwtService.destroyToken();
        }
    },
    [SET_USER](state, user) {
        state.currentUser = Object.assign({}, user);
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.error = {};
        state.currentUser = {};
        state.requiresTwoFactor = false;
        state.emailNotConfirmed = false;
        JwtService.destroyToken();
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
